import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { SelectCaseDialogComponent } from '../selectCaseDialog/select-case-dialog.component';
export interface Sender {
  docId: number;
  alphanum_Fileno: string;
  process: string;
  recipient: { empName: string; unitId: number }[];
  selectedRadio: {
    empName: string;
    unitId: number;
    toOrderNo: number;
    roleId: number;
    mpgType: number;
    subHrchyLvlPk: number;
  };
  showMsg: boolean;
}

export interface FileHierarchy {
  empId: number;
  empName: string;
  recNo: string;
  recId: number;
  refId: number[];
  unitId: number;
}

export interface ForwardData {
  customXidBean: string;
  dbSchema: string;
  extendedVO: string;
  fileHierarchyVOArr: FileHierarchy[];
  ms: string;
  recId: number;
  recNo: string;
  subjectName: string;
  msg: string;
}

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'app-dg-forward',
  templateUrl: './dg-forward.component.html',
  styleUrls: ['./dg-forward.component.scss'],
})
export class ForwardCaseComponent implements OnInit {
  dataSource: Sender[] = [];
  SENDER_DATA: Sender[] = [];
  singleData: Sender = {
    docId: null,
    alphanum_Fileno: null,
    process: null,
    recipient: [],
    selectedRadio: null,
    showMsg: false,
  };
  showTable = false;
  caseData: CaseView[] = [];
  refIdList = '';
  selectedRadio: { empName: string; unitId: number };
  showMsg = false;
  postData = {
    refId: [],
    toUnit: [],
    toOrderNo: [],
    roleId: [],
    toMpgType: [],
    applTypeId: 1,
    movmentActionFlag: 1,
    fromGrpId: null,
    toGrpId: null,
    fromType: null,
    toType: null,
    toRoleId: null,
    delegationVO: null,
    fromGrpWS: null,
    groupLevel: null,
    groupUnitId: null,
    groupId: null,
    recall: null,
    papsFlag: false,
    line: null,
    subHrhcyLvlPk: null,
  };
  docId: number;
  recep = {};
  displayedColumns: string[] = ['alphanum_Fileno', 'process', 'recipient'];
  selectedUnit: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ForwardCaseComponent>
  ) {}

  ngOnInit(): void {
    this.caseData = this.data?.selectedData;
    for (let s of this.caseData) {
      this.refIdList += s.docId.toString() + ',';
    }
    this.refIdList = this.refIdList.slice(0, -1);
    let params = new HttpParams();
    params = params.append(
      'appTypeId',
      this.caseData?.[0]?.appTypeId === '3' ? '3' : '1'
    );
    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '610');
    params = params.append('recNo', this.refIdList);
    params = params.append('organizationId', '54');
    this.http
      .get('/workflow/hierarchy-details', { params: params })
      .subscribe((res: { data: ForwardData[] }) => {
        const restemp: { data: ForwardData[] } = res;
        this.showTable = true;
        if (!restemp.data.length) {
          this.singleData.recipient.push({
            empName: 'No person is mapped above you',
            unitId: 0,
          });
          this.singleData.showMsg = true;
        } else {
          this.singleData.showMsg = false;
          for (const val of this.caseData) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;
            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH: any = s.fileHierarchyVOArr;
                if (!fileH || fileH.length === 0) {
                  this.singleData.recipient.push({ empName: s.msg, unitId: 0 });
                  this.singleData.showMsg = true;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                      subHrchyLvlPk: m.subHrchyLvlPk,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
            }
            this.SENDER_DATA.push(this.singleData);
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              recipient: [],
              selectedRadio: null,
              showMsg: false,
            };
          }
        }
        this.dataSource = this.SENDER_DATA;
      });
  }

  onSend(): void {
    let flag = 0;
    for (const s of this.dataSource) {
      this.postData.refId.push(Number(s.docId));
      if (!s.selectedRadio) {
        flag++;
      } else {
        this.postData.applTypeId = this.caseData[0]?.appTypeId === '3' ? 3 : 1;
        this.postData.toUnit.push(s.selectedRadio.unitId);
        this.postData.toOrderNo.push(s.selectedRadio?.toOrderNo);
        this.postData.toMpgType.push(s.selectedRadio?.mpgType);
        this.postData.subHrhcyLvlPk = s.selectedRadio?.subHrchyLvlPk;
        if (s.selectedRadio?.mpgType === 657) {
          this.postData.roleId.push(s.selectedRadio?.roleId);
        } else {
          this.postData.roleId.push(-1);
        }
        if (s.selectedRadio?.mpgType === 658) {
          this.postData.toGrpId = s.selectedRadio?.unitId;
          this.postData.toType = 1970;
        }
      }
    }

    if (flag) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: 'Please select a recipient for each case.',
      });
    } else {
      if (!this.data?.isFromCustomAction) {
        this.http.post('/workflow/workflow-operation', this.postData).subscribe(
          () => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.dialogRef.close(false);
          }
        );
      } else {
        this.dialogRef.close(this.postData);
      }
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(SelectCaseDialogComponent, {
      width: '60%',
      height: '70%',
      data: { selectedData: this.caseData },
    });

    dialogRef.afterClosed().subscribe((result: CaseView[]) => {
      if (result) {
        this.caseData = result;
        this.ngOnInit();
      }
    });
  }

  onRecipientSelected(recipient: any, index: number): void {
    this.dataSource[index].selectedRadio = recipient;
  }

  isForwardButtonDisabled = (): boolean => {
    for (const data of this.dataSource) {
      if (!data.selectedRadio) {
        return true;
      }
    }
    return false;
  };
}
